/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

import { bemGenerator } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';

import PasswordInput from '../../../components/password-input';
import Setting from '../setting';

import './index.scss';

const styles = bemGenerator('password-setting', ['setting', 'error']);

class PasswordSetting extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      oldPassword: '',
      newPassword: '',
    };

    this.onOldPasswordChange = this.onOldPasswordChange.bind(this);
    this.onNewPasswordChange = this.onNewPasswordChange.bind(this);
  }

  onOldPasswordChange(e) {
    this.setState({
      oldPassword: e.target.value,
    });
  }

  onNewPasswordChange(e) {
    this.setState({
      newPassword: e.target.value,
    });
  }

  cancelChange() {
    this.setState({
      oldPassword: '',
      newPassword: '',
    });

    this.props.onStopEditing();
  }

  submitChange() {
    this.props.onChange({
      currentPassword: this.state.oldPassword,
      newPassword: this.state.newPassword,
    });
  }

  renderError() {
    return (
      <div key={this.props.error} className={styles.error}>
        {this.props.error}
      </div>
    );
  }

  handleKeyUp(evt) {
    if (evt.key === 'Enter') {
      this.submitChange();
    }

    if (evt.key === 'Escape') {
      this.cancelChange();
    }
  }

  renderEditing() {
    const { newPassword, oldPassword } = this.state;
    const { t } = this.context;
    return (
      <div>
        {this.props.label}
        <div className={styles.setting}>
          <PasswordInput
            name="oldPassword"
            label={t('account', 'settings.old-password')}
            value={oldPassword}
            onChange={this.onOldPasswordChange}
            tabIndex="0"
          />
        </div>

        <div className={styles.setting}>
          <PasswordInput
            name="newPassword"
            label={t('account', 'settings.new-password')}
            value={newPassword}
            onChange={this.onNewPasswordChange}
          />
        </div>
        {this.props.error && this.renderError()}
      </div>
    );
  }

  render() {
    return (
      <Setting
        label={this.props.label}
        saving={this.props.saving}
        editable={this.props.editable}
        editing={this.props.editing}
        value="********"
        saveButtonDisabled={!this.state.oldPassword || !this.state.newPassword}
        onStartEditing={() => this.props.onStartEditing()}
        onCancel={() => this.cancelChange()}
        onSave={() => this.submitChange()}
        render={props => this.renderEditing(props)}
      />
    );
  }
}

PasswordSetting.contextType = AppContext;

PasswordSetting.propTypes = {
  label: PropTypes.string,
  oldPassword: PropTypes.string,
  newPassword: PropTypes.string,
  editable: PropTypes.bool,
  editing: PropTypes.bool,
  error: PropTypes.string,
  saving: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onStartEditing: PropTypes.func,
  onStopEditing: PropTypes.func,
};

PasswordSetting.defaultProps = {
  label: '',
  oldPassword: '',
  newPassword: '',
  editable: true,
  editing: false,
  error: undefined,
  saving: false,
  onStartEditing: () => {},
  onStopEditing: () => {},
};

export default PasswordSetting;
